export default __webpack_public_path__ + "static/media/scan-border.491a40c4.svg";